export default __webpack_public_path__ + "static/media/Engineering.ff30f868.png";